import React from 'react';

interface ModuleCardProps {
  module: any;
  onLessonSelect: (lesson: any) => void;
}

const ModuleCard: React.FC<ModuleCardProps> = ({ module, onLessonSelect }) => {
  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-indigo-50 rounded-xl flex items-center justify-center text-2xl">
          {module.emoji}
        </div>
        <div>
          <h2 className="font-bold text-gray-900 leading-tight">{module.title}</h2>
          <p className="text-xs text-gray-500 uppercase tracking-wider font-semibold">
            {module.lessons?.length || 0} aulas
          </p>
        </div>
      </div>
      
      <div className="space-y-1">
        {module.lessons?.map((lesson: any) => (
          <button 
            key={lesson.id} 
            onClick={() => onLessonSelect(lesson)}
            className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-xl transition-colors group text-left"
          >
            <div className="flex items-center gap-3">
              <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs ${
                lesson.completed ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"
              }`}>
                {lesson.completed ? "✓" : "○"}
              </div>
              <div>
                <p className={`text-sm font-medium ${lesson.completed ? "text-gray-500 line-through" : "text-gray-700"}`}>
                  {lesson.title}
                </p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-[10px] text-gray-400 flex items-center gap-1 font-medium">
                    ⏱ {lesson.duration}
                  </span>
                  {lesson.has_video && (
                    <span className="text-[10px] text-indigo-400 font-bold uppercase tracking-tighter">Video</span>
                  )}
                </div>
              </div>
            </div>
            <div className="text-gray-300 group-hover:text-indigo-500 transition-colors">
              →
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ModuleCard;
